import { observer } from 'mobx-react-lite'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { type OCRScopingJobSidePanelViewModel } from '@/features/jobs/scoping/OCRScopingJobSidePanelViewModel'
import { type CreateOCRScopeJobsViewModel } from '@/features/jobs/scoping/components/CreateOCRScopeJobsDialog/CreateOCRScopeJobsViewModel'
import { type OCRScopingJobMainPanelViewModel } from '@/features/jobs/scoping/OCRScopingJobMainPanelViewModel'
import { OCRConfirmBulkSubmitDialogContainer } from '@/features/jobs/scoping/components/OCRConfirmBulkSubmitDialog/OCRConfirmBulkSubmitDialogContainer'
import { OCRConfirmBulkReviewDialogContainer } from '@/features/jobs/scoping/components/OCRConfirmBulkReviewDialog/OCRConfirmBulkReviewDialogContainer'
import { OCRConfirmBulkRerunDialogContainer } from '@/features/jobs/scoping/components/OCRConfirmBulkRerunDialog/OCRConfirmBulkRerunDialogContainer'
import { OCRBulkProgressDialogContainer } from '@/features/jobs/scoping/components/OCRBulkProgressDialog/OCRBulkProgressDialogContainer'
import {
  OCRScopingJobSidePanel,
  OCRScopingJobSidePanelContent,
} from '@/features/jobs/scoping/components/OCRScopingJobSidePanel'
import { OCRScopingJobsListHeaderContainer } from '@/features/jobs/scoping/components/OCRScopingJobsListHeader/OCRScopingJobsListHeaderContainer'
import { OCRScopeJobItemContainer } from '@/features/jobs/scoping/components/OCRScopeJobItem/OCRScopeJobItemContainer'
import { OCRBulkActionButtonContainer } from '@/features/jobs/scoping/components/OCRBulkActionButton/OCRBulkActionButtonContainer'

export interface OCRScopingJobSidePanelContainerProps {
  vm: OCRScopingJobSidePanelViewModel
  createScopeJobsVm: CreateOCRScopeJobsViewModel
  mainPanelVm: OCRScopingJobMainPanelViewModel
}

export const OCRScopingJobSidePanelContainer = observer(
  function OCRScopingJobSidePanelContainer({
    vm,
    createScopeJobsVm,
    mainPanelVm,
  }: OCRScopingJobSidePanelContainerProps) {
    const bulkActionVm = vm.bulkActionVm
    const selectedStatusFilter = vm.selectedStatusFilter
    return (
      <OCRScopingJobSidePanel>
        <OCRScopingJobSidePanelContent
          header={<OCRScopingJobsListHeaderContainer vm={vm} />}
          showList={!!selectedStatusFilter}
          items={
            selectedStatusFilter &&
            vm.ocrScopeWorkJobs.map((scopeWorkJob) => (
              <OCRScopeJobItemContainer
                vm={bulkActionVm}
                mainPanelVm={mainPanelVm}
                item={scopeWorkJob}
                selectedStatusFilterId={selectedStatusFilter.id}
                key={scopeWorkJob.id}
              />
            ))
          }
          loader={
            !vm.scroller.isDone && (
              <InfiniteScrollLoaderContainer scrollProvider={vm.scroller} />
            )
          }
          footer={
            <>
              <OCRBulkActionButtonContainer
                vm={vm}
                createScopeJobsVm={createScopeJobsVm}
              />
              <OCRConfirmBulkSubmitDialogContainer
                vm={bulkActionVm.confirmBulkSubmitDialogVm}
              />
              <OCRConfirmBulkReviewDialogContainer
                vm={bulkActionVm.confirmBulkReviewDialogVm}
              />
              <OCRConfirmBulkRerunDialogContainer
                vm={bulkActionVm.confirmBulkRerunDialogVm}
              />
              <OCRBulkProgressDialogContainer
                vm={bulkActionVm.bulkProgressDialogVm}
              />
            </>
          }
        />
      </OCRScopingJobSidePanel>
    )
  },
)
